import escapeStringRegexp from 'escape-string-regexp';
import { isNullOrUndefined } from './is-null-or-undefined';

export function createSearchPattern(pattern: string, flag?: string): RegExp {
  pattern ??= '';
  flag ??= 'gi';

  let tokens = pattern.split(/\s+/g).map(t => t.trim()).filter(t => !!t.length);

  tokens = tokens.map(t => escapeStringRegexp(t));

  pattern = `(?:${tokens.join(')\\s*(?:')})`;

  let regex = new RegExp(pattern, flag);
  let _test = regex.test;

  regex.test = (str: string) => {
    regex.lastIndex = 0;
    return _test.call(regex, str);
  };

  return regex;
}

export function createTokenizedSearchPattern(pattern: string, flag: string = 'i'): RegExp[] {
  if (!pattern || pattern?.trim() == '')
    return [];

  return pattern.split(/\s+/).map(x => createSearchPattern(x, flag));
}
